import { ref } from "@knyt/artisan";
import { track } from "./tracking.js";
/**
 * Creates a reactive state reference that requests an update
 * on the given host when its value changes.
 */
export function hold(host, initialValue, arg1) {
    let options;
    if (typeof arg1 === "function") {
        options = { initialValue, onUpdate: arg1 };
    }
    else {
        options = { ...arg1, initialValue };
    }
    const state = ref(initialValue, options);
    track(host, state);
    return state;
}
